import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UserProvider } from '../../providers/user/user';
import * as _ from 'lodash';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';
@Component({
  selector: 'verification-prompts',
  templateUrl: 'verification-prompts.html',
})
export class VerificationPromptsComponent {
  // types = short, tall or drawer
  @Input() promptType: string = 'short';
  //if type = tall then options =  first or second
  // First - shows man in hat
  // Second - shows animated cards
  @Input() tallTypeOptions: string = 'first';

  postOptions = ['first', 'second', 'short'];
  verificationSteps = ['Confirm Info', 'Verified'];
  manInHat = 'assets/imgs/verification/man_in_hat.svg';
  verified;
  authedUser;

  tall_first_carosel_content = [
    {
      icon: `<i class="fa fa-pencil"></i>`,
      info: 'Post in the Feed',
    },
    {
      icon: `<i class="fal fa-comments"></i>`,
      info: 'Comment on Posts',
    },
    {
      icon: `<i class="fa fa-user fa-fw"></i>`,
      info: 'Add Friends',
    },
  ];

  infoText =
    this.tallTypeOptions === 'first'
      ? 'Unlock more features and ensure a community of real truckers, easy and completely free!'
      : 'Complete the simple and free verification steps to unlock more features and ensure a community of real truckers';

  constructor(
    public user: UserProvider,
    public verification: UserVerificationProvider
  ) {}

  ngOnInit() {
    this.verified = this.verification.getVerificationStatus();
    this.authedUser = !this.user.get('states.isUnauthedUser');
  }

  getVerified() {
    this.verification.showGetVerifiedOverlay();
  }
}



// WEBPACK FOOTER //
// ./src/components/verification-prompts/verification-prompts.ts